import { SET_ERRORS, CLEAR_ERRORS } from '../constants/errorsConstants';

export function setError(str) {
    return { type: SET_ERRORS, payload: str };
}

export function clearErrors() {
    return { type: CLEAR_ERRORS };
}
